import type { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';

export class WrikeMissingTranslationHandler implements MissingTranslationHandler {
    handle(params: MissingTranslationHandlerParams): string {
        return params.key;
    }
}
